/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Button } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='sprites'>
        <Sprite name='loader'>
            <Button hitArea={{ width: -1, x: 0, y: 0, type: 'rectangle', height: -1 }} name='dot'>
                <Sprite>
                    <Image src='preloader_dot_normal' />
                </Sprite>
                <Sprite>
                    <Image src='preloader_dot_normal' />
                </Sprite>
                <Sprite>
                    <Image src='preloader_dot_disabled' />
                </Sprite>
                <Sprite>
                    <Image src='preloader_dot_disabled' />
                </Sprite>
            </Button>
        </Sprite>
    </Sprite>
);
